import { cloneDeep } from '@apollo/client/utilities';
import { EntityInput, forCreate, forDelete, forUpdate } from '../common/entity';
import { BinStatus } from './binStatus';

export class BinStatusInput extends BinStatus implements EntityInput<BinStatus> {
  forCreate(): CreateBinStatusInput {
    return CreateBinStatusInput.from(this, CreateBinStatusInput);
  }

  forUpdate(): UpdateBinStatusInput {
    return UpdateBinStatusInput.from(this, UpdateBinStatusInput);
  }

  forDelete(): DeleteBinStatusInput {
    return DeleteBinStatusInput.from(this, DeleteBinStatusInput);
  }

  validate() {
    if (!this.status) return false;
    if (!this.color) return false;

    return true;
  }

  hasChanges(original: BinStatus | undefined): boolean {
    if (!original) return true;

    if (this.status !== original.status) return true;
    if (this.color !== original.color) return true;
    if (this.inboundAllowed != original.inboundAllowed) return true;
    if (this.outboundAllowed != original.outboundAllowed) return true;

    return false;
  }

  withStatus(status: string) {
    this.status = status;
    return cloneDeep(this);
  }

  withColor(color: string) {
    this.color = color;
    return cloneDeep(this);
  }

  withInboundAllowed(inboundAllowed: boolean) {
    this.inboundAllowed = inboundAllowed;
    return cloneDeep(this);
  }

  withOutboundAllowed(outboundAllowed: boolean) {
    this.outboundAllowed = outboundAllowed;
    return cloneDeep(this);
  }
}

export class CreateBinStatusInput extends forCreate(BinStatus) {}

export class UpdateBinStatusInput extends forUpdate(BinStatus) {}

export class DeleteBinStatusInput extends forDelete(BinStatus) {}
